import React, { useState } from 'react';
import { Card, Col, Form, InputNumber, Row, Select, Switch, Typography } from 'antd';

export interface BenchmarkCardsConfig {
  fields: string[];
  showParent: boolean;
  cardSpan: number;
}

const DEFAULT_BENCHMARK_CARDS_CONFIG: BenchmarkCardsConfig = {
  fields: ['average'],
  showParent: true,
  cardSpan: 24,
};

interface Props {
  initialConfig?: Partial<BenchmarkCardsConfig>;
  fieldOptions?: Array<{ label: string; value: string }>;
  onChange: (config: BenchmarkCardsConfig) => void;
}

export const SectionConfigBenchmarkCards: React.FC<Props> = ({ initialConfig, fieldOptions, onChange }) => {
  const [config, setConfig] = useState<BenchmarkCardsConfig>({
    ...DEFAULT_BENCHMARK_CARDS_CONFIG,
    ...initialConfig,
  });

  const updateField = (field: keyof BenchmarkCardsConfig, value: any) => {
    const nextConfig = { ...config, [field]: value };
    setConfig(nextConfig);
    onChange(nextConfig);
  };

  return (
    <Card size="small" style={{ background: '#f5f5f5' }}>
      <Form.Item label="Aggregations to classify">
        <Select
          mode="multiple"
          allowClear
          options={fieldOptions || []}
          value={config.fields}
          onChange={(values) => updateField('fields', values)}
        />
      </Form.Item>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Show parent area">
            <Switch
              checked={config.showParent}
              onChange={(checked) => updateField('showParent', checked)}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Card width (span)" help="1-24 columns">
            <InputNumber
              min={1}
              max={24}
              value={config.cardSpan}
              onChange={(value) => updateField('cardSpan', value || 24)}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        Each selected aggregation is converted into a benchmark label (Poor to Perfect).
      </Typography.Text>
    </Card>
  );
};

export default SectionConfigBenchmarkCards;
